const SPECIAL_EVENT_LANGUAGE_CATEGORY_IDS = ["93", "94", "96", "99", "101"];

export const getSpecialEventLanguageLabel = (
  item = {},
  { includeProfessionalDemonstration = true } = {}
) => {
  const baseCategoryIds = includeProfessionalDemonstration
    ? SPECIAL_EVENT_LANGUAGE_CATEGORY_IDS
    : SPECIAL_EVENT_LANGUAGE_CATEGORY_IDS.filter((categoryId) => categoryId !== "101");

  const categoryIds = process.env.REACT_APP_COACHING_GROUP_SESSION_ID
    ? [
        ...baseCategoryIds,
        String(process.env.REACT_APP_COACHING_GROUP_SESSION_ID),
      ]
    : baseCategoryIds;

  if (!categoryIds.includes(String(item.ondemand_session_category_id))) {
    return "";
  }

  const languageLabel = `(${item.language})`;
  const levelLabel = item.practice_circle_level_label
    ? ` (${item.practice_circle_level_label})`
    : "";

  return `${languageLabel}${levelLabel}`;
};
